import React from "react";
import Faq from "../components/Faq/Faq.jsx";

const FaqPage = () => {
  return (
    <div>
      <Faq />
    </div>
  );
};

export default FaqPage;
